import React, {MouseEventHandler, ReactElement} from 'react'
import {Fab, useMediaQuery} from '@mui/material'

type Props = {
    onClick: MouseEventHandler
    label: string
    icon: () => ReactElement
    disabled?: boolean
}

export const FabButton = ({ onClick, label, icon, disabled }: Props) => {
    // @ts-ignore
    const matches = useMediaQuery(theme => theme.breakpoints.up('lg'))

    return matches ? (
        <Fab title={label} onClick={onClick} color='primary' variant='extended' size={'medium'} disabled={disabled}>
            {icon()}
            {label}
        </Fab>
    ) : (
        <Fab title={label} onClick={onClick} color='primary' size={'medium'}  disabled={disabled}>
            {icon()}
        </Fab>
    )
}
